<script setup lang="ts">
import { type ShopSelectItem } from "~/models/Shop"

/**
 *
 *  Props and emits section
 *
 *
 */

const props = defineProps<{
    store: ShopSelectItem
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
const categories = computed(() => {
    return (props.store?.categories ?? []).slice(0, 6)
})
function goToStore() {
    navigateTo(`/store/${props.store.slug}`)
}
</script>

<template>
    <div
        @click="goToStore"
        class="tw-bg-white tw-border tw-border-gray-200 tw-p-4 tw-flex tw-flex-col tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all tw-duration-300 hover:tw-shadow-lg hover:tw-scale-105 tw-group"
    >
        <div
            class="tw-flex tw-items-center tw-justify-center tw-mb-2 tw-flex-1 tw-w-[155px] tw-h-[155px]"
        >
            <img
                v-if="store.logo"
                :src="store.logo"
                :alt="`Logo de ${store.name}`"
                class="tw-w-full tw-h-full tw-object-contain tw-transition-transform tw-duration-300 group-hover:tw-scale-110"
            />
        </div>
        <p
            class="tw-text-primary tw-text-md tw-font-bold tw-text-center tw-line-clamp-1 tw-self-start"
        >
            {{ store.name }}
        </p>
        <div class="tw-flex tw-flex-wrap tw-gap-2 tw-mt-4">
            <q-badge
                class="tw-h-7 tw-bg-[#DFDFDF] tw-text-[12px] tw-font-normal tw-rounded-[50px] py-2 md:py-6 px-2 md:px-4 tw-text-[#404040] tw-flex tw-items-center tw-justify-center"
                v-for="tag in categories"
                :key="tag.id"
            >
                <div
                    class="py-2 md:py-4 px-2 md:px-4 tw-text-[10px] md:tw-text-[12px] tw-font-normal tw-text-[#404040] tw-line-clamp-1"
                >
                    {{ tag.name }}
                </div>
            </q-badge>
        </div>
    </div>
</template>

<style scoped>
.tw-line-clamp-1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-clamp: 1;
}
</style>
